module.exports = __webpack_public_path__ + "img/character04_static.3a391eb0.png";